import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import parse from 'html-react-parser';
import { useNavigate } from 'react-router-dom';

function SingleArticle({page_title}) {

    useEffect(() => {
                                document.title = page_title;
                            }, [page_title]);

    const { id } = useParams();
    const [article, setArticle] = useState([]);
    const navigate = useNavigate();
    
    useEffect(() => {
        fetch(`https://annalsofnursing.org/aon_backend/api/api.php?action=getArticleById&id=${id}`)
        .then((res) => res.json())
        .then((data) => {
            if (data.success) {
            setArticle(data.article);
            } else {
            console.error("API error:", data.error);
            }
        })
        .catch((err) => console.error("Fetch error:", err));
    }, [id])


    const openArticlePdf = (file, e) => {
        e.stopPropagation();
        e.preventDefault();

        if (file) {
            // Split into path + filename
            const lastSlashIndex = file.lastIndexOf('/');
            let path = '';
            let filename = file;

            if (lastSlashIndex !== -1) {
                path = file.substring(0, lastSlashIndex + 1); // include trailing slash
                filename = file.substring(lastSlashIndex + 1);
            }

            // Encode only the filename, not the whole path
            const encodedFile = path + encodeURIComponent(filename);

            window.open(encodedFile, '_blank');
        }
    };
    


    return (
        <div className='instructions_section'>
            <div className="instructions_wrapper">

                <div className='sarticle_wrapper'>

                    <h1 className='sarticle_title'>{article.title?.toUpperCase()}</h1>

                    <p className='sarticle_subtitle'><span className='article_block_type'>{article.type?.toUpperCase()}</span> | BY {article.authors?.toUpperCase()}</p>

                    <div className='sarticle_button_wrapper'>
                        <div 
                            className='sarticle_pdf_button' 
                            onClick={(e) => openArticlePdf(article.file, e)}
                        >
                            <span className="fa-solid fa-file-pdf"></span>
                            &nbsp;
                            Download Article PDF

                        </div>
                    </div>

                    <p className='sarticle_abstract_title'>Abstract:</p>

                    <p className='sarticle_abstract_content'>
                         {article.abstract && parse(article.abstract)}
                    </p>

                    <div className='sarticle_keywords'>
                        {article.keywords?.split(',').map((keyword, index) => (
                            <div key={index} className="article_block_key_word">
                                {keyword.trim()}
                            </div>
                        ))}
                    </div>

                    <div className='sarticle_back' onClick={() => navigate(-1)}>
                        <span class="fa-solid fa-arrow-left-long"></span>&nbsp;&nbsp;Back
                    </div>


                </div>

                

            </div>
        </div>
    );
}

export default SingleArticle;
